import React, { useState } from "react";
import { Form, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { IconButton, Typography, Box } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PersonIcon from "@mui/icons-material/Person";
import RealEstateAgentIcon from '@mui/icons-material/RealEstateAgent';
import VisibilityIcon from "@mui/icons-material/Visibility";

const ReusableForm = ({ selectedTemplateConfig, formFields, onChange, handleGeneratePreview }) => {
  const groupLabels = {
    contact: "VARIABLE Fields",
    customer: "FIXED Fields",
  };
  const [validated, setValidated] = useState(false);
  const sections = {
    contact: selectedTemplateConfig.contact || [],
    customer: selectedTemplateConfig.customer || [],
  };
  return (
    <Form
      noValidate
      className="premium-form"
      onSubmit={(e) => {
        e.preventDefault();
        setValidated(true);
        const hasErrors = Object.entries(selectedTemplateConfig).some(
          ([group, fields]) =>
            Array.isArray(fields) &&
            fields.some(
              (f) =>
                (f.required === true || f.required === "true") &&
                !formFields[group]?.[f.name]?.trim()
            )
        );
        if (hasErrors) {
          const firstInvalid = document.querySelector(".is-invalid");
          if (firstInvalid) {
            firstInvalid.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstInvalid.focus();
          }
          return;
        }
        handleGeneratePreview();
      }}
    >
      {Object.entries(sections).map(([group, fields]) => (
        <fieldset key={group} style={{ marginBottom: '10px', border: 'none' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
            {group === 'contact' ? <PersonIcon sx={{ color: '#2f539b' }} /> : <RealEstateAgentIcon sx={{ color: '#2f539b' }} />}
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', fontSize: '1.1rem' }}>
              {groupLabels[group]}
            </Typography>
          </Box>

          <Box sx={{ display: 'grid', gap: 1 }}>
            {fields.map((field) => (
              <Form.Group
                controlId={`form-${field.name}`}
                key={field.name}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                  <Form.Label style={{ fontWeight: 600, color: '#475569', fontSize: '0.85rem', margin: 0 }}>
                    {field.label}
                    {(field.required === "true" || field.required === true) && (
                      <span style={{ color: "#ef4444", marginLeft: '4px' }}>*</span>
                    )}
                  </Form.Label>
                  {field.maxLength && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{`Max ${field.maxLength} characters`}</Tooltip>}
                    >
                      <IconButton size="small" tabIndex={-1} sx={{ color: '#94a3b8', p: 0.5 }}>
                        <HelpOutlineIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </OverlayTrigger>
                  )}
                </Box>

                <Form.Control
                  type="text"
                  name={field.name}
                  autoComplete={field.name}
                  value={formFields[group]?.[field.name] || ""}
                  onChange={(e) => onChange(e, group, field.name, field.type)}
                  maxLength={field.maxLength ? field.maxLength : null}
                  placeholder={field.placeholder ? field.placeholder : ""}
                  isInvalid={
                    validated &&
                    (field.required === true || field.required === "true") &&
                    !formFields[group]?.[field.name]?.trim()
                  }
                  style={{
                    borderRadius: '8px',
                    padding: '8px 12px',
                    fontSize: '0.9rem',
                    backgroundColor: '#fff',
                    border: '1px solid #e2e8f0',
                    transition: 'all 0.2s ease',
                  }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.25, minHeight: '1.25rem' }}>
                  {validated && (field.required === true || field.required === "true") && !formFields[group]?.[field.name]?.trim() && (
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '0.75rem', display: 'block', margin: 0 }}>
                      {field.label} is required
                    </Form.Control.Feedback>
                  )}

                  {field.maxLength && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: (formFields[group]?.[field.name] || "").length >= field.maxLength ? '#ef4444' : '#94a3b8',
                        fontWeight: (formFields[group]?.[field.name] || "").length >= field.maxLength ? 700 : 400,
                        ml: 'auto',
                        fontSize: '0.7rem'
                      }}
                    >
                      {(formFields[group]?.[field.name] || "").length}/{field.maxLength}
                    </Typography>
                  )}
                </Box>
              </Form.Group>
            ))}
          </Box>
        </fieldset>
      ))}

      <Button
        variant="primary"
        type="submit"
        className="generate-button"
        style={{
          background: 'var(--primary-gradient)',
          border: 'none',
          padding: '5px 15px 7px',
          fontWeight: 700,
          borderRadius: '8px',
          width: 'fit-content',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px',
          boxShadow: '0 4px 12px rgba(47, 83, 155, 0.2)',
          fontSize: '0.82rem'
        }}
      >
        <VisibilityIcon sx={{ fontSize: 16 }} />
        Preview
      </Button>
    </Form>
  );

};
export default ReusableForm;